// extracted by extract-css-chunks-webpack-plugin
module.exports = {"file":"File__file"};